import currency from 'currency.js';
import { getOrderTotalPrice } from '../order/get-order-total-price';
import { getOrderPaidAmount } from './get-order-paid-amount';
export const getOrderUnpaidBalance = () => {
    const totalOrderCost = getOrderTotalPrice().valueIncludingTax;
    const amountPaid = getOrderPaidAmount();
    return currency(totalOrderCost).subtract(amountPaid).value;
};
